var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12 mb-2" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between" },
          [
            _vm.product !== "aduanas"
              ? _c(
                  "h4",
                  { staticClass: "text-primary" },
                  [
                    _vm._v(" Gestión de "),
                    _vm.groupMood ? _c("span", [_vm._v("usuarios")]) : _vm._e(),
                    !_vm.groupMood
                      ? _c("span", [_vm._v("oficinas")])
                      : _vm._e(),
                    _c(
                      "b-form-checkbox",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.top",
                            value: "Después de hacer click, espere",
                            expression: "'Después de hacer click, espere'",
                            modifiers: { hover: true, top: true }
                          }
                        ],
                        staticClass: "ml-3",
                        attrs: {
                          name: "check-button",
                          switch: "",
                          inline: "",
                          "data-cy": "cambioDeGrupoAOficina"
                        },
                        model: {
                          value: _vm.groupMood,
                          callback: function($$v) {
                            _vm.groupMood = $$v
                          },
                          expression: "groupMood"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "switch-icon-left",
                            attrs: { "data-cy": "oficinas" }
                          },
                          [
                            _c("feather-icon", { attrs: { icon: "UsersIcon" } })
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "switch-icon-right",
                            attrs: { "data-cy": "grupos" }
                          },
                          [
                            _c("feather-icon", { attrs: { icon: "AwardIcon" } })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.product === "aduanas"
              ? _c("h4", { staticClass: "text-primary" }, [
                  _vm._v(" Gestión de usuarios ")
                ])
              : _vm._e(),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Descargar información de usuarios",
                    expression: "'Descargar información de usuarios'"
                  }
                ],
                attrs: {
                  variant: "primary",
                  size: "sm",
                  "data-cy": "download-users-report"
                },
                on: {
                  click: function($event) {
                    return _vm.downloadUsersReport(true)
                  }
                }
              },
              [
                _c("feather-icon", {
                  staticClass: "mr-3",
                  attrs: { icon: "DownloadIcon" }
                }),
                _vm._v(" Descargar ")
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "groups col-4 bg-white shadow" },
        [
          _c("groups-tree", {
            attrs: { groupMood: _vm.groupMood },
            on: { select: _vm.onSelectedTreeItem }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-8 bg-white shadow" },
        [
          _c(
            "b-tabs",
            [
              _vm.selectedGroup.nombre !== _vm.company.razonSocial
                ? _c(
                    "b-tab",
                    { attrs: { title: "Detalles" } },
                    [
                      _c("b-card-text", [
                        _vm.selectedGroup.nombre &&
                        _vm.selectedGroup.nombre !== _vm.company.razonSocial
                          ? _c("div", { staticClass: "row mb-5" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-6 mt-3" },
                                [
                                  _c("vs-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      readonly: "true",
                                      label: "Código",
                                      maxlength: "40",
                                      name: "groupName"
                                    },
                                    model: {
                                      value: _vm.selectedGroup.codigo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedGroup,
                                          "codigo",
                                          $$v
                                        )
                                      },
                                      expression: "selectedGroup.codigo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mt-3" },
                                [
                                  _c("vs-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      readonly: "true",
                                      label: "Nombre de Grupo",
                                      maxlength: "250",
                                      name: "groupName"
                                    },
                                    model: {
                                      value: _vm.selectedGroup.nombre,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedGroup,
                                          "nombre",
                                          $$v
                                        )
                                      },
                                      expression: "selectedGroup.nombre"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-12 mt-3" },
                                [
                                  _c("vs-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      readonly: "true",
                                      label: "Descripción de Grupo",
                                      maxlength: "250",
                                      name: "groupDescription"
                                    },
                                    model: {
                                      value: _vm.selectedGroup.descripcion,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedGroup,
                                          "descripcion",
                                          $$v
                                        )
                                      },
                                      expression: "selectedGroup.descripcion"
                                    }
                                  })
                                ],
                                1
                              ),
                              this.action !== "addParent"
                                ? _c("div", { staticClass: "col-md-12 mt-3" }, [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "vs-select",
                                          {
                                            staticClass: "w-100",
                                            attrs: {
                                              readonly: "true",
                                              autocomplete: "",
                                              disabled: "",
                                              label: "Es oficina",
                                              name: "isOffice"
                                            },
                                            model: {
                                              value:
                                                _vm.selectedGroup.esOficina,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.selectedGroup,
                                                  "esOficina",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "selectedGroup.esOficina"
                                            }
                                          },
                                          [
                                            _c("vs-select-item", {
                                              attrs: { value: "Y", text: "Si" }
                                            }),
                                            _c("vs-select-item", {
                                              attrs: { value: "N", text: "No" }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm.selectedGroup.esOficina === "Y"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "row mt-3",
                                            staticStyle: { cursor: "none" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-4" },
                                              [
                                                _c("label", [
                                                  _vm._v("Es tipo de oficina")
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-4" },
                                              [
                                                _c(
                                                  "vs-radio",
                                                  {
                                                    attrs: {
                                                      disabled: "",
                                                      "vs-value": "int"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedGroup.tipo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedGroup,
                                                          "tipo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedGroup.tipo"
                                                    }
                                                  },
                                                  [_vm._v(" Interna ")]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-4" },
                                              [
                                                _c(
                                                  "vs-radio",
                                                  {
                                                    attrs: {
                                                      disabled: "",
                                                      "vs-name": "isPrivate",
                                                      "vs-value": "ext"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedGroup.tipo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedGroup,
                                                          "tipo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedGroup.tipo"
                                                    }
                                                  },
                                                  [_vm._v(" Externa ")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm.selectedGroup.entidadDocDigital
                                ? _c(
                                    "div",
                                    { staticClass: "col-md-12 mt-3" },
                                    [
                                      _c("vs-input", {
                                        staticClass: "w-100",
                                        attrs: {
                                          readonly: "true",
                                          label: "Código",
                                          maxlength: "40",
                                          name: "groupName"
                                        },
                                        model: {
                                          value:
                                            _vm.selectedGroup
                                              .descripcionEntidadDocDigital,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.selectedGroup,
                                              "descripcionEntidadDocDigital",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedGroup.descripcionEntidadDocDigital"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                { attrs: { active: "", title: "Usuarios" } },
                [
                  _c(
                    "b-card-text",
                    { attrs: { id: "list-users" } },
                    [
                      _c("user-table", {
                        attrs: {
                          users: _vm.usersTree,
                          group: _vm.selectedGroup
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "mt-4 mb-4" },
                        [
                          _c("fb-paginacion", {
                            attrs: { total: _vm.pagination.pages, max: 10 },
                            model: {
                              value: _vm.page,
                              callback: function($$v) {
                                _vm.page = $$v
                              },
                              expression: "page"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "getReportModal",
          attrs: {
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Descargar reporte de usuarios"
          },
          on: { hidden: _vm.resetModal }
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loadingParameters } }, [
            _c("strong", [_vm._v("Seleccione los parámetros para el reporte")]),
            _c(
              "div",
              { staticClass: "mt-4 row justify-content-between" },
              _vm._l(_vm.optionsReport, function(option) {
                return _c(
                  "div",
                  { key: option.key, staticClass: "col-6" },
                  [
                    _c("b-form-group", {
                      attrs: { label: "Categoría " + option.nombre },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var ariaDescribedby = ref.ariaDescribedby
                              return [
                                _c("b-form-checkbox-group", {
                                  attrs: {
                                    options: option.campos,
                                    "aria-describedby": ariaDescribedby,
                                    switches: "",
                                    stacked: "",
                                    "value-field": "key",
                                    "text-field": "nombre"
                                  },
                                  model: {
                                    value: _vm.selected,
                                    callback: function($$v) {
                                      _vm.selected = $$v
                                    },
                                    expression: "selected"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.downloadUsersReport(false)
                      }
                    }
                  },
                  [_vm._v(" Enviar ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }